<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
  console.log(
    "%c%s",
    "color: blue; font-size: 16px;",
    "本项目由极客实验室开发\n\n作者邮箱admin@osuu.net \n\n你可以通过 https://h234.cn 了解我们 \n\n人生苦短、必须性感 "
  );
  export default {
    name: "app",
    created() {
      // 在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store")) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
      }

      // 在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload", () => {
        sessionStorage.setItem("store", JSON.stringify(this.$store.state))
      })

      // 判断设备
      if(document.body.clientWidth < 992){
        this.$store.state.isMobile = true
      }else{
        this.$store.state.isMobile = false
      }
    }

  };
</script>

<style>
  @import url("//at.alicdn.com/t/font_2572248_s9eye03lqmd.css");

</style>